<template>
	<div class="article-breakingnews">
		<ListBox
			:title="heading"
			:list="articles"
			:fields="['image','headline','subhead','date']"
		/>
	</div>
</template>

<script>
import store from '../store'

import globalMixins from '@/mixins/global-mixins'

import ListBox from '@/components/list/Box'

export default {
	name: 'ArticleBreakingNews',
	components: {
		ListBox
	},
	mixins: [
		globalMixins
	],
	props: {
		id: {
			type: String,
			default: 'cmeInfoBar'
		},
	},
	computed: {
		content() {
			return store.getters.breakingNews
		},
		heading() {
			return this.content?.heading || null
		},
		articles() {
			return this.content?.articles || null
		}
	}
}
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_config.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/animations.css"></style>
<style src="@/assets/css/main.css"></style>